import { IAddedNotificationQueryParam } from '@halo/interfaces/added-notification-query-param'
import WhiteLabelModel from '@halo/models/white-label.model'

export class AccountDto {
    public static fromApiResponse(fields: Partial<AccountDto>): AccountDto {
        const dto = new AccountDto()

        Object.assign(dto, fields)

        return dto
    }

    public readonly id: number
    public name: string
    public status: string = 'ACTIVE'
    public status_id: number = 1
    public flags: string[] = []
    public keywords: string[] = []

    public vapid_public_key: string
    public vapid_private_key: string
    public default_notification_ttl_seconds: number
    public added_notification_query_params: { [key: string]: IAddedNotificationQueryParam }
    public utm_params: any
    public global_prompt_settings: any
    public frequency_caps: any
    public media_quality: number
    public billing_data: any
    public display_meta: any
    public timezone: string
    public default_notification_landing_url: string

    public collapse_key_type: string
    public routing_key: string

    public readonly platformWhitelabelId: number
    public readonly created_by: number
    public readonly created_at: Date
    public created_by_user_name: string
    public readonly updated_by: number
    public readonly updated_at: Date
    public updated_by_user_name: string

    public domains: any[]
    public getDomainCount(): number {
        return (this.domains || []).length
    }
}
